export default __webpack_public_path__ + "static/media/coffee.68aa51e7.svg";